import {AxiosInstance} from "axios";
import {AgendaAppointment} from "@/core/interfaces/AgendaAppointment";
import {AgendaRenewalReminder} from "@/core/interfaces/AgendaRenewalReminder";
import {AgendaBirthday} from "@/core/interfaces/AgendaBirthday";

export interface AgendaIndexRequest {
    from: string;
    to: string;
    operator_ids?: number[];
    appointment_type_ids?: number[];
    customer_id?: number;
    include_canceled?: boolean;
}

export interface AgendaBirthdayRequest {
    from: string;
    to: string;
}

export interface AgendaWindow {
    appointments: AgendaAppointment[];
    /** Upcoming-renewal reminders sent inside the same window. */
    reminders: AgendaRenewalReminder[];
}

const AgendaResource = (hdsClient: AxiosInstance) => {
    return {
        /**
         * Get what the agenda shows over the requested window: the
         * appointments overlapping it, plus the renewal reminders sent in it.
         * The day, week, month and per-collaborator views all consume this
         * single endpoint; grouping is done client-side.
         */
        async index(organizationId: number, request: AgendaIndexRequest): Promise<AgendaWindow> {
            const response = await hdsClient.get(`organizations/${organizationId}/agenda`, {
                params: request
            });

            return {
                appointments: response.data.data,
                reminders: response.data.renewal_reminders ?? []
            };
        },

        /**
         * The targeted patient birthdays of a window: those an active gift
         * matches. A separate call rather than a key of the agenda window —
         * the overlay is off by default, so it must not cost a patient join
         * on every agenda navigation.
         */
        async birthdays(organizationId: number, request: AgendaBirthdayRequest): Promise<AgendaBirthday[]> {
            const response = await hdsClient.get(`organizations/${organizationId}/birthdays`, {
                params: request
            });

            return response.data.data;
        }
    };
};

export default AgendaResource;
